import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, CheckCircle2, Layers, TrendingDown, Flame } from "lucide-react";

function Stat({ icon: Icon, label, value, tint }) {
  return (
    <div className="rounded-3xl border border-[#E5DECF] bg-white p-5">
      <div className="flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl" style={{ background: `${tint}1A` }}><Icon size={22} color={tint} /></div>
        <div><div className="text-xs uppercase tracking-wide font-semibold text-[#6B7280]">{label}</div><div className="font-heading text-2xl font-extrabold text-[#1F2937]">{value}</div></div>
      </div>
    </div>
  );
}

export default function AdminStats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.adminStats().then(setS).catch(() => {}); }, []);
  if (!s) return <div className="p-16 text-center font-cursive text-2xl text-[#0D9488] animate-pulse">Loading…</div>;

  return (
    <div className="mx-auto max-w-5xl px-4 py-8 sm:px-6 sm:py-10">
      <div className="text-xs uppercase tracking-widest font-bold text-[#7A3FF2]">Platform Admin</div>
      <h1 className="mt-1 font-heading text-3xl sm:text-4xl font-extrabold text-[#1F2937]">Platform Statistics</h1>
      <div className="mt-6 grid gap-4 sm:grid-cols-3">
        <Stat icon={Users} label="Active Students" value={s.active_students} tint="#0D9488" />
        <Stat icon={CheckCircle2} label="Activities Completed" value={s.activities_completed} tint="#10B981" />
        <Stat icon={Layers} label="Total Activities" value={s.total_activities} tint="#F59E0B" />
      </div>

      <div className="mt-8 grid gap-6 lg:grid-cols-2">
        <div className="rounded-3xl border border-[#E5DECF] bg-white p-6">
          <div className="flex items-center gap-2 text-[#E05A47]"><TrendingDown size={18} /><h2 className="font-heading text-lg font-bold">Most Difficult Activities</h2></div>
          <div className="mt-3 space-y-2">
            {s.hardest_activities.length === 0 ? <p className="text-[#94A3B8] text-sm">No attempts yet.</p> :
              s.hardest_activities.map((a) => (
                <div key={a.activity_id} className="flex items-center justify-between rounded-xl bg-[#F2ECE1] px-4 py-2">
                  <span className="font-semibold text-[#1F2937]">{a.title}</span>
                  <span className="text-sm font-bold text-[#B4402F]">{a.avg_score}% avg · {a.attempts}x</span>
                </div>
              ))}
          </div>
        </div>
        <div className="rounded-3xl border border-[#E5DECF] bg-white p-6">
          <div className="flex items-center gap-2 text-[#F59E0B]"><Flame size={18} /><h2 className="font-heading text-lg font-bold">Most Practiced</h2></div>
          <div className="mt-3 space-y-2">
            {s.most_practiced.length === 0 ? <p className="text-[#94A3B8] text-sm">No attempts yet.</p> :
              s.most_practiced.map((a) => (
                <div key={a.activity_id} className="flex items-center justify-between rounded-xl bg-[#F2ECE1] px-4 py-2">
                  <span className="font-semibold text-[#1F2937]">{a.title}</span>
                  <span className="text-sm font-bold text-[#6B7280]">{a.attempts} attempts</span>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
